import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Link, ThemeProvider, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { Translate } from 'react-jhipster';
import HandymanIcon from '@mui/icons-material/Handyman';
import { Build, ContentPasteSearchRounded } from '@mui/icons-material';

interface IModalTestNewModules {
  newsOpens: boolean;
  setNewsOpen: (value: boolean) => void;
  module: string;
}

export const ModalTestNewModules: React.FC<IModalTestNewModules> = ({ newsOpens, setNewsOpen, module }) => {
  const theme = useTheme();
  const messageParts = [
    {
      key: 'maintenance',
      title: 'Bem-vindo ao Módulo de Manutenção!',
      text: 'Você está entrando no Módulo de Manutenção, um dos nossos novos recursos em fase de testes. Esta ferramenta foi desenvolvida para tornar a gestão de manutenção mais eficiente e organizada.',
      subtitle: 'Funcionalidades Principais:',
      list: [
        'Notificações: Tenha lembretes e alertas para tarefas importantes, garantindo que nada seja esquecido.',
        'Histórico Completo: Mantenha um registro detalhado de todas as intervenções e atividades de manutenção. ',
      ],
      alertText:
        'Atenção: Este módulo está disponível para teste por tempo limitado. Aproveite para explorar e nos fornecer feedback valioso para melhorias futuras! Estamos aqui para ajudar você a tirar o máximo proveito deste recurso. Qualquer dúvida, entre em contato com nossa',
      suport: 'equipe de suporte!',
    },
    {
      key: 'inspection',
      title: 'Bem-vindo ao Módulo de Inspeção!',
      text: 'Você está entrando no Módulo de Inspeção, uma das nossas novas funcionalidades em fase de testes. Estamos entusiasmados em oferecer esta ferramenta poderosa para ajudá-lo a otimizar seus processos de inspeção.',
      subtitle: 'Funcionalidades Principais:',
      list: [
        'Checklists Personalizáveis: Crie listas de verificação adaptadas às suas necessidades específicas.',
        'Monitoramento: Acompanhe a conformidade e identifique problemas à medida que apontados.',
        'Históricos Detalhados: Tenha acesso ao histórico de inspeções para facilitar a análise e a tomada de decisões.',
      ],
      alertText:
        'Atenção: Este módulo está disponível para teste por tempo limitado. Aproveite para explorar e nos fornecer feedback valioso para melhorias futuras! Estamos aqui para ajudar você a tirar o máximo proveito deste recurso. Qualquer dúvida, entre em contato com nossa',
      suport: 'equipe de suporte!',
    },
    {
      key: 'AllNews',
      title: 'Novidades! Teste os Novos Módulos de Inspeção e Manutenção.',
      text: 'Estamos animados em anunciar duas novas funcionalidades em nossa plataforma: os módulos de Inspeção e Manutenção.',
      subtitle: 'Módulo de Inspeção:',
      list: ['Checklists Personalizáveis.', 'Monitoramento.', 'Históricos Detalhados.'],
      SecondSubtitle: 'Módulo de Manutenção:',
      SecondList: ['Notificações.', 'Histórico Completo.'],
      alertText:
        'Estes módulos estão disponíveis para teste por tempo limitado. Aproveite esta oportunidade para explorar e experimentar essas novas ferramentas que podem melhorar significativamente a eficiência e a qualidade do seu trabalho. Estamos aqui para ajudar você a tirar o máximo proveito deste recurso. Qualquer dúvida, entre em contato com nossa',
      suport: 'equipe de suporte!',
    },
  ];

  const message = messageParts.find(part => part.key === module);

  const handleClose = () => {
    setNewsOpen(false);
  };

  const WhatsAppMessage = () => {
    const whatsMessage = 'Olá! Vim da plataforma da Sigaway e gostaria de saber mais sobre os novos módulos de Inspeção e Manutenção. Poderia me ajudar?';
    const url = `https://api.whatsapp.com/send/?phone=${+554834782425}&text=${encodeURIComponent(whatsMessage)}&type=phone_number&app_absent=0`;
    window.open(url, '_blank');
  };

  const ButtonActions = propsButton => (
    <Button
      {...propsButton}
      onClick={handleClose}
      component={Link}
      sx={{ gap: '4px', margin: '5px', textTransform: 'none', padding: '8px 22px;', height: '38px' }}
    >
      {propsButton.children}
    </Button>
  );

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={newsOpens}
        onClose={handleClose}
        onBackdropClick={handleClose}
        aria-labelledby="dialog-title"
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiPaper-root': {
            margin: '10px',
            borderRadius: '16px',
            background: theme.palette.background.default,
            [theme.breakpoints.down('md')]: {
              maxWidth: '92vw !important',
            },
          },
        }}
      >
        <DialogContent dividers>
          <Box display={'flex'} flexDirection={'column'}>
            <Box padding={1} display={'flex'} justifyContent={'center'}>
              <Typography variant="h5" sx={{ fontWeight: 'fontWeightBold' }}>
                {message.title}
              </Typography>
            </Box>
            <Divider />
            <Box mt={1} mb={1}>
              <Typography variant="body1">{message.text}</Typography>
            </Box>
            <Box mt={1}>
              <Box display={'flex'}>
                {module !== 'maintenance' && <ContentPasteSearchRounded sx={{ mr: 1 }} />}
                {module === 'maintenance' && <Build sx={{ mr: 1 }} />}
                <Typography variant="subtitle1">{message.subtitle}</Typography>
              </Box>
              <ul>
                {message.list.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </Box>
            {module === 'AllNews' && (
              <Box mt={1}>
                <Box display={'flex'}>
                  <Build sx={{ mr: 1 }} />
                  <Typography variant="subtitle1">{message.SecondSubtitle}</Typography>
                </Box>
                <ul>
                  {message.SecondList.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </Box>
            )}
            <Box mt={1} mb={1} display={'flex'}>
              <Typography variant="body2" sx={{ fontWeight: '600' }}>
                {message.alertText}
                <Typography
                  component={Link}
                  variant="body2"
                  onClick={WhatsAppMessage}
                  sx={{ fontWeight: 'bold', color: 'secondary.main', '&:hover': { color: '#13be71' }, textDecoration: 'underline', ml: '3px' }}
                >
                  {message.suport}
                </Typography>
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box width={'100%'} display={'flex'} justifyContent={'center'}>
            <ButtonActions variant="contained" color="secondary">
              <Translate contentKey="entity.action.confirm">Confirm</Translate>
            </ButtonActions>
          </Box>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
